export default __webpack_public_path__ + "RPD_logotype_skyblue.png?3b8ffdfb7827acdb6ab4bd461d627637";